export default rendererMode => {
    return {
        hocs: [],
        computeLink: ({ node }) => {
            return node.props.link ? 'link mock' : undefined;
        },
        onNavigate: () => null
    };
};